import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ToggleThemeButton from 'src/components/settings/ToggleThemeButton';
import { PATH_DASHBOARD } from 'src/routes/paths';
import MyAvatar from '../../../components/MyAvatar';
import useAdminInfoStore from '../../../store/admin';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
  const { adminInfo } = useAdminInfoStore();

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          bgcolor: 'transparent',
        }),
      }}
    >
      <div className="flex items-center">
        <Link to={PATH_DASHBOARD.general.myProfile}>
          <MyAvatar avatarSrc={adminInfo?.Avatar} />
        </Link>

        <Box
          sx={{
            ml: 2,
            height: 'fit-content',
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          }}
        >
          <Typography variant="subtitle2" noWrap sx={{ '&:empty': { display: 'none' } }}>
            {adminInfo?.Name}
          </Typography>
          <Typography variant="body2" noWrap sx={{ color: 'text.secondary', '&:empty': { display: 'none' } }}>
            {adminInfo?.LastName}
          </Typography>
        </Box>
      </div>
      {!isCollapse && <ToggleThemeButton />}
    </RootStyle>
  );
}
